import script from "./BButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BButton.vue?vue&type=script&setup=true&lang=js"

import "./BButton.vue?vue&type=style&index=0&id=1f16d765&lang=scss"

const __exports__ = script;

export default __exports__